import imageOne from '@/assets/images/cities/pickering1.jpg'
import imageTwo from '@/assets/images/cities/pickering2.jpg'
import imageThree from '@/assets/images/cities/pickering3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Pickering',
  writeup: '',
  website: 'PickeringNotary.com',
  url: 'https://www.pickeringnotary.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '1 (800) 813 6084',
      hours: {
        monday: '6:00PM to 9:00PM',
        tuesday: '6:00PM to 9:00PM',
        wednesday: '6:00PM to 9:00PM',
        thursday: '6:00PM to 9:00PM',
        friday: '6:00PM to 9:00PM',
        saturday: '9:30AM to 6:00PM',
        sunday: '9:30AM to 4:30PM'
      },
      address: 'Strouds Lane Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontarioGTA/cities/pickering.js